import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  class: "flex flex-row",
  style: {"width":"100% !important"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TreatmentCard = _resolveComponent("TreatmentCard")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_TimerCard = _resolveComponent("TimerCard")!

  return (_openBlock(), _createElementBlock("div", {
    key: _ctx.componentKey,
    class: "room flex flex-none",
    style: _normalizeStyle({ minWidth: _ctx.minWidth, width: _ctx.minWidth })
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.numBlocks, (v, i) => {
        return (_openBlock(), _createElementBlock("div", {
          key: `room-${_ctx.id}-block-${i}`,
          class: "block",
          style: _normalizeStyle({ backgroundColor: _ctx.theme })
        }, [
          (
            _ctx.occupied
            && !!_ctx.filteredTreatments[i]
            && !!_ctx.filteredTreatments[i].treatment
          )
            ? (_openBlock(), _createBlock(_component_TreatmentCard, {
                key: 0,
                id: _ctx.filteredTreatments[i].uuid,
                treatment: _ctx.filteredTreatments[i],
                room: _ctx.room,
                appointment: _ctx.appointment,
                "appointment-id": _ctx.appointment.uuid,
                disabled: _ctx.activeTreatmentId && !(_ctx.filteredTreatments[i].uuid === _ctx.activeTreatmentId),
                initials: _ctx.$filters.initials(_ctx.filteredTreatments[i].doctor.name),
                initialsColor: _ctx.filteredTreatments[i].doctor.color,
                "room-id": _ctx.id,
                title: _ctx.filteredTreatments[i].treatment.name,
                "initial-allocated-time": _ctx.filteredTreatments[i].duration * 1000,
                "started-at": _ctx.filteredTreatments[i].started_at,
                "ended-at": _ctx.filteredTreatments[i].ended_at
              }, null, 8, ["id", "treatment", "room", "appointment", "appointment-id", "disabled", "initials", "initialsColor", "room-id", "title", "initial-allocated-time", "started-at", "ended-at"]))
            : _createCommentVNode("", true),
          (_ctx.occupied && (i + 1) === _ctx.filteredTreatments.length && !!_ctx.filteredTreatments[i] !== undefined && _ctx.fitsTheFilter)
            ? (_openBlock(), _createBlock(_component_v_card, {
                key: 1,
                class: "gray-tile add-button",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$store.dispatch(
            'selectAppointment',
            { appointment: { ..._ctx.appointment, room: _ctx.room }
          })))
              }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode(" + ", -1)
                ]))]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ], 4))
      }), 128))
    ]),
    _createElementVNode("div", {
      class: "block block--final",
      style: _normalizeStyle({ backgroundColor: _ctx.theme })
    }, [
      (_ctx.occupied && _ctx.showTimer)
        ? (_openBlock(), _createBlock(_component_TimerCard, {
            key: 0,
            "appointment-state": "inactive",
            appointment: _ctx.appointment,
            "number-of-treatments": _ctx.appointment.treatments.length,
            "room-id": _ctx.id,
            "is-disabled": !_ctx.fitsTheFilter,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.fitsTheFilter ? _ctx.$store.dispatch('selectAppointment', { appointment: _ctx.appointment }) : null))
          }, null, 8, ["appointment", "number-of-treatments", "room-id", "is-disabled"]))
        : _createCommentVNode("", true)
    ], 4)
  ], 4))
}